import { multiply, divide } from '@pushpay/styles';
/* eslint-disable import/prefer-default-export */

export const GUTTER = '8px'; // Values here are hard coded rather than multiple of GUTTER to make it easy for the consumer to see what value they are using

export const NONE = '0';
export const XXSMALL = '4px'; // GUTTER * 0.5

export const XSMALL = GUTTER;
export const SMALL = '16px'; // GUTTER * 2

export const MEDIUM = '24px'; // GUTTER * 3

export const LARGE = '32px'; // GUTTER * 4

export const XLARGE = '40px'; // GUTTER * 5
// todo this should be 40px we always multiply it by 2

export const FIELD_HEIGHT = '20px';
export const FIELD_PADDING_V = '10px';
export const FIELD_PADDING_H = '12px';
export const FIELD_PADDING = `${FIELD_PADDING_V} ${FIELD_PADDING_H}`;
export const FIELD_SPACING_V = '12px';
export const FIELD_SPACING_H = '12px';
export const FIELD_TO_MESSAGE = '5px';
export const FIELD_BORDER_WIDTH = '1px';
export const FIELD_LABEL_WIDTH = '200px';
export const FIELD_LABEL_HEIGHT = multiply(FIELD_HEIGHT, 2);
export const FIELD_PLACEHOLDER_WIDTH = '155px';
export const DYNAMIC_FIELD_MOBILE_HEIGHT = multiply(FIELD_PADDING_V, 2);
export const LARGE_ICON_SIZE = '20px';
export const MEDIUM_ICON_SIZE = '16px';
export const SMALL_ICON_SIZE = '12px';
export const ICON_TO_TEXT = '8px';
export const ICON_TO_TEXT_ERROR = divide(ICON_TO_TEXT, 2);
export const FIELD_ICON_SIZE = MEDIUM_ICON_SIZE;
export const FIELD_VALIDATION_ICON_SIZE = MEDIUM_ICON_SIZE;
export const DEFAULT_DROPDOWN_OVERLAY_TO_TEXT_WIDTH = 30;
export const CHECKABLE_OPTION_PADDING = '0.25em';
export const CHECKBOX_SIZE = '20px';
export const CHECKBOX_PADDING = '10px';